import { TransferBaseRequestDto } from './transfer-base-request.dto';
import { TransferRecordIdentityKey } from './transfer-record-identity-key.dto';

export class CheckOutRecordDto extends TransferBaseRequestDto {
	public TransferRecord: TransferRecordIdentityKey[];
	public BusinessUnit: string;
	public LoggingStyle: string;
	public SstnLoggingStyle: string;
	public Workfile: string;
	public RecordId: string;

	public constructor(params: Required<CheckOutRecordDto>) {
		super({
			AuthenticationMethod: params.AuthenticationMethod,
			Environment: params.Environment
		});
		this.TransferRecord = params.TransferRecord;
		this.BusinessUnit = params.BusinessUnit;
		this.LoggingStyle = params.LoggingStyle;
		this.SstnLoggingStyle = params.SstnLoggingStyle;
		this.Workfile = params.Workfile;
		this.RecordId = params.RecordId;
	}
}
